// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"122":"86a0e981","2953":"555113c4","4964":"e2358af9","5641":"8755c301"}[chunkId] + ".chunk.css";
};